import {Observable, Subscription} from 'rxjs';

import IPlaybackStore from '../Interfaces/IPlaybackStore';

const subscribeToKeypressSpace = (
    keypressSpace$: Observable<Event>,
    playbackStore: IPlaybackStore
): Subscription =>
    keypressSpace$
        .subscribe((e: Event) => {
            e.preventDefault();

            playbackStore.value.isPlaying ?
                playbackStore.actions.pause() :
                playbackStore.actions.play();
        });

export default subscribeToKeypressSpace;